/*
  Always-on accessibility attribute fixes for markup the theme cannot author
  directly (Shopify's `video_tag` poster image and the native video-player
  iframe injected at runtime). These only add ARIA/alt/title attributes — no
  visual or behavioural change.
*/
(function () {
  'use strict';

  function fixVideoPosters(root) {
    // Shopify's video_tag outputs a poster <img> with no alt inside the <video>.
    // The poster is decorative (the video conveys the content), so alt="".
    var imgs = root.querySelectorAll('.hero-video-preview img:not([alt]), video > img:not([alt])');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('alt', '');
    }
  }

  function fixIframes(root) {
    // The native video player injects helper iframes (e.g. #PBarNextFrame) with
    // no accessible name. Give any unnamed iframe a title.
    var frames = root.querySelectorAll('iframe:not([title]):not([aria-label]):not([aria-labelledby])');
    for (var i = 0; i < frames.length; i++) {
      var frame = frames[i];
      if (frame.getAttribute('aria-hidden') === 'true') continue;
      var id = frame.id || '';
      frame.setAttribute('title', /pbar|player|video/i.test(id) ? 'Video player' : 'Embedded content');
    }
  }

  function sweep() {
    try {
      fixVideoPosters(document);
      fixIframes(document);
    } catch (e) {}
  }

  function init() {
    sweep();
    // The poster image and player iframe can appear after first paint, so watch
    // for additions and re-run.
    try {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          sweep();
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
